// Circled "i" used on informational notes and the build-info row. Decorative —
// always paired with the visible note text, so it is aria-hidden. Size via CSS
// font-size (renders at 1em); color via currentColor.
export function InfoIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...(className ? { className } : {})}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      {/* Near-zero-length line: round caps render it as the "i" dot. */}
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}
